import type { BoardSummaryRecord, DeviceProfile } from "@contracts";
import {
  IconActivityHeartbeat,
  IconBox,
  IconChevronDown,
  IconDeviceFloppy,
  IconHistory,
  IconLayersIntersect2,
  IconPlayerPlay,
  IconRefresh,
  IconRocket,
  IconSettings,
  IconArrowBackUp,
  IconArrowForwardUp,
} from "@tabler/icons-react";
import type { PreviewMode } from "./store";

interface TopbarProps {
  boardName: string;
  boardId: string;
  boards: BoardSummaryRecord[];
  devices: DeviceProfile[];
  deviceId: string;
  previewMode: PreviewMode;
  dirty: boolean;
  saveState: "idle" | "saving" | "saved" | "error";
  busy: boolean;
  canUndo: boolean;
  canRedo: boolean;
  onDevice: (id: string) => void;
  onBoard: (id: string) => void;
  onNewBoard: () => void;
  onPreviewMode: (mode: PreviewMode) => void;
  onSave: () => void;
  onPublish: () => void;
  onUndo: () => void;
  onRedo: () => void;
  onSources: () => void;
  onDevices: () => void;
  onReleases: () => void;
  onRefresh: () => void;
}

export function Topbar(props: TopbarProps) {
  return <header className="topbar">
    <div className="brand" aria-label="ScreenCanvas">
      <IconLayersIntersect2 size={31} stroke={1.7} />
      <span>ScreenCanvas</span>
    </div>
    <span className="topbar-divider" />
    <label className="board-switch" title="切换屏幕">
      <select value={props.boardId} onChange={(event) => event.target.value === "__new" ? props.onNewBoard() : props.onBoard(event.target.value)}>
        {props.boards.map((board) => <option key={board.id} value={board.id}>{board.name}</option>)}
        <option value="__new">＋ 新建屏幕…</option>
      </select><IconChevronDown size={17} />
    </label>
    <div className="topbar-spacer" />
    <label className="device-select-wrap" title="输出设备">
      <select value={props.deviceId} onChange={(event) => props.onDevice(event.target.value)}>
        {props.devices.map((device) => <option key={device.id} value={device.id}>{device.name.replace("（逆时针）", "")} · {device.design.width}×{device.design.height}</option>)}
      </select>
      <IconChevronDown size={17} />
    </label>
    <nav className="topbar-tools" aria-label="管理工具">
      <button title="撤销 (⌘Z)" onClick={props.onUndo} disabled={!props.canUndo}><IconArrowBackUp size={19} /></button>
      <button title="重做 (⇧⌘Z)" onClick={props.onRedo} disabled={!props.canRedo}><IconArrowForwardUp size={19} /></button>
      <button title={props.dirty ? "保存草稿 (⌘S)" : "草稿已保存"} onClick={props.onSave} className={props.dirty ? "has-dot" : ""}><IconDeviceFloppy size={19} /></button>
      <button title="刷新实时数据" onClick={props.onRefresh}><IconRefresh size={19} /></button>
      <button title="数据源" onClick={props.onSources}><IconActivityHeartbeat size={19} /></button>
      <button title="设备预设" onClick={props.onDevices}><IconSettings size={19} /></button>
      <button title="发布与版本" onClick={props.onReleases}><IconHistory size={19} /></button>
    </nav>
    <div className="preview-modes" role="group" aria-label="预览模式">
      <span>预览模式</span>
      <button className={props.previewMode === "design" ? "active" : ""} onClick={() => props.onPreviewMode("design")}><IconBox size={16} />设计</button>
      <button className={props.previewMode === "gray" ? "active" : ""} onClick={() => props.onPreviewMode("gray")}><IconPlayerPlay size={16} />灰度</button>
      <button className={props.previewMode === "device" ? "active" : ""} onClick={() => props.onPreviewMode("device")}><IconRocket size={16} />设备</button>
    </div>
    <button className="publish-button" onClick={props.onPublish} disabled={props.busy}>
      <IconRocket size={20} />
      <span>{props.busy ? "发布中" : "发布"}</span>
    </button>
  </header>;
}
